import { render } from "./FileDrop.vue?vue&type=template&id=65de4cdf&scoped=true"
import script from "./FileDrop.vue?vue&type=script&lang=js"
export * from "./FileDrop.vue?vue&type=script&lang=js"

import "./FileDrop.vue?vue&type=style&index=0&id=65de4cdf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65de4cdf"]])

export default __exports__